export enum ConnectionMode {
  default,
  maintenance,
}
